import { useEffect, useState } from 'react';
import { loadAll } from './data.ts';
import { DataContext, useFestivalData, type DataState } from './festivalData.ts';
import type { FestivalData } from './types.ts';

export function DataProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<DataState>({ data: null, error: null, loading: true });

  useEffect(() => {
    let cancelled = false;
    loadAll()
      .then(data => { if (!cancelled) setState({ data, error: null, loading: false }); })
      .catch((err: unknown) => {
        const message = err instanceof Error ? err.message : String(err);
        if (!cancelled) setState({ data: null, error: message, loading: false });
      });
    return () => { cancelled = true; };
  }, []);

  return <DataContext.Provider value={state}>{children}</DataContext.Provider>;
}

/* Convenience component: renders children only once data is loaded. */
export function DataGate({ children }: { children: (data: FestivalData) => React.ReactNode }) {
  const { data, error, loading } = useFestivalData();
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-10 text-center bg-mf-yellow">
        <div>
          <div className="font-display text-3xl text-mf-black mb-2">Noget gik galt</div>
          <div className="text-mf-black/70">{error}</div>
        </div>
      </div>
    );
  }
  if (loading || !data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-mf-yellow">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-mf-black/60">Indlæser…</div>
      </div>
    );
  }
  return children(data);
}
